export default __webpack_public_path__ + "static/media/milestone 600.0990beb7.svg";